import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';

export const getCookies = ({ cookies }: RootState) => cookies?.cookies;

export const getCustomerID = createSelector(
  getCookies,
  (cookies) => cookies?.customerId ?? cookies?._ym_uid,
);

export const getApiOption = createSelector(getCookies, (cookies) => cookies?.['x-api-option']);
